import { render, staticRenderFns } from "./CollateralItem.vue?vue&type=template&id=6bd67ae0&scoped=true&"
import script from "./CollateralItem.vue?vue&type=script&lang=js&"
export * from "./CollateralItem.vue?vue&type=script&lang=js&"
import style0 from "./CollateralItem.vue?vue&type=style&index=0&id=6bd67ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd67ae0",
  null
  
)

export default component.exports